import {Injectable, Inject} from 'ng-metadata/core';
const angular:angular.IAngularStatic =  require('angular');


@Injectable()
export class PrimoExploreService {
	private _classes :Set<string> = new Set<string>(); //CSS classes for <primo-explore> directive
	private primoExploreElement;


	private getPrimoExploreElement() {
		if(this.primoExploreElement) {
			return this.primoExploreElement;
		}
		else {
			let elm = document.querySelector('primo-explore');
			if(!elm) {
				return;
			}
			this.primoExploreElement = elm;
			return this.primoExploreElement;

		}
	}
	/**
	 * Turn the whole screen dark
	 * @param dimScreen - {true|false} required
	 */
	public dimScreen(dimScreen :boolean){
		if ( angular.isDefined(dimScreen) ){
			dimScreen  ? this.addCSSClass( 'background-dark' ) : this.removeCSSClass( 'background-dark' );
		}
	}


	/**
	 * Inject CSS class to <primo-explore> directive
	 * @param cssClass
	 */
	private addCSSClass( cssClass: string ) {
		let elementObj = this.getPrimoExploreElement();
		if ( elementObj ) {
			elementObj.classList.add( cssClass );
		}
	}

	/**
	 * Remove CSS class from <primo-explore> directive
	 * @param cssClass
	 */
	private removeCSSClass( cssClass: string ) {
		let elementObj = this.getPrimoExploreElement();
		if ( elementObj ) {
			elementObj.classList.remove( cssClass );
		}
	}



}


//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/primoExplore.service.ts